import { CrossSectoralStandardsUsed } from '../interfaces/IFootprint';

// UI dropdown label -> value the backend expects when saving.
const CROSS_SECTORAL_STANDARD_BACKEND_VALUES: Record<string, string> = {
  [CrossSectoralStandardsUsed.PACT_V2]: 'Pathfinder v2',
  [CrossSectoralStandardsUsed.ISO_STANDARD_14040_44]: 'ISO 14040-44',
  [CrossSectoralStandardsUsed.PACT_V3]: 'Pathfinder v3',
  [CrossSectoralStandardsUsed.GHGP_PRODUCT]: 'GHG Protocol Product',
};

// backend value -> UI dropdown label. Built as the reverse of the map above, plus older (v7)
// API labels that also need to resolve to a current dropdown value.
const CROSS_SECTORAL_STANDARD_DISPLAY_VALUES: Record<string, string> = {
  ...Object.fromEntries(
    Object.entries(CROSS_SECTORAL_STANDARD_BACKEND_VALUES).map(([uiValue, backendValue]) => {
      return [backendValue, uiValue];
    }),
  ),
  // Existing v7 data uses these labels.
  'ISO Standard 14067': CrossSectoralStandardsUsed.ISO_STANDARD_14067,
  'ISO Standard 14040': CrossSectoralStandardsUsed.ISO_STANDARD_14040_44,
  'ISO Standard 14044': CrossSectoralStandardsUsed.ISO_STANDARD_14040_44,
};

export const mapCrossSectoralStandardToBackendValue = (uiValue: string): string => {
  return CROSS_SECTORAL_STANDARD_BACKEND_VALUES[uiValue] ?? uiValue;
};

// Falls back to the bare value when there's no known match.
export const mapCrossSectoralStandardToDisplayValue = (backendValue: string): string => {
  return CROSS_SECTORAL_STANDARD_DISPLAY_VALUES[backendValue] ?? backendValue;
};
